export enum ConfirmModalResultEnum {
    Cancel = 'cancel',
    Confirm = 'confirm'
}
